function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("path", {
  fill: "#6098F6",
  fillRule: "nonzero",
  d: "M61.444 14.897c-1.621 0-2.935-1.314-2.935-2.935V5.87H42.882v6.092c0 1.621-1.314 2.935-2.935 2.935-1.62 0-2.935-1.314-2.935-2.935V2.935c0-1.62 1.314-2.935 2.935-2.935h21.496c1.621 0 2.935 1.314 2.935 2.935v9.027c0 1.621-1.313 2.935-2.934 2.935z",
  transform: "translate(2)"
}), React.createElement("path", {
  fill: "#216FF3",
  fillRule: "nonzero",
  d: "M61.444 0H50.695v5.87h7.814v6.092c0 1.621 1.314 2.935 2.935 2.935 1.62 0 2.935-1.314 2.935-2.935V2.935C64.379 1.314 63.065 0 61.444 0z",
  transform: "translate(2)"
}), React.createElement("path", {
  fill: "#5692F6",
  fillOpacity: 0.2,
  fillRule: "nonzero",
  d: "M73.948 90H27.442c-1.572 0-2.865-1.24-2.932-2.81L21.71 21.113c-.071-1.667 1.263-3.059 2.932-3.059H76.75c1.668 0 3.002 1.392 2.932 3.06L76.88 87.188C76.814 88.761 75.52 90 73.948 90z",
  transform: "translate(2)"
}), React.createElement("g", {
  fillRule: "nonzero"
}, React.createElement("path", {
  fill: "#6098F6",
  d: "M58.75 9.09H32.695v71.945h23.253c1.573 0 2.866-1.24 2.932-2.81l2.802-66.076c.07-1.667-1.263-3.058-2.932-3.058z",
  transform: "translate(2) translate(18 8.965)"
}), React.createElement("path", {
  fill: "#5692F6",
  d: "M62.455 14.96H2.936c-1.62 0-2.935-1.314-2.935-2.935V2.998C.001 1.377 1.315.063 2.936.063h59.518c1.621 0 2.935 1.314 2.935 2.935v9.027c0 1.621-1.314 2.935-2.934 2.935z",
  transform: "translate(2) translate(18 8.965)"
})), React.createElement("path", {
  fill: "#216FF3",
  fillRule: "nonzero",
  d: "M80.455 9.028h-29.76v14.897h29.76c1.62 0 2.934-1.314 2.934-2.935v-9.027c0-1.621-1.314-2.935-2.934-2.935z",
  transform: "translate(2)"
}), React.createElement("g", {
  fill: "#88B8F2",
  fillOpacity: 0.8,
  fillRule: "nonzero"
}, React.createElement("path", {
  d: "M2.959 42.206c-1.62 0-2.935-1.314-2.935-2.935V2.935C.024 1.314 1.338 0 2.96 0c1.62 0 2.935 1.314 2.935 2.935V39.27c0 1.621-1.314 2.935-2.935 2.935zM14.765 42.206c-1.62 0-2.935-1.314-2.935-2.935V2.935C11.83 1.314 13.144 0 14.765 0c1.62 0 2.935 1.314 2.935 2.935V39.27c0 1.621-1.314 2.935-2.935 2.935z",
  transform: "translate(2) translate(35.93 35.86)"
})), React.createElement("g", {
  fill: "#88B8F2",
  fillRule: "nonzero"
}, React.createElement("path", {
  d: "M0 0v42.206c1.62 0 2.934-1.314 2.934-2.935V2.935C2.934 1.315 1.621 0 0 0zM11.805 42.206c-1.62 0-2.934-1.314-2.934-2.935V2.935C8.87 1.314 10.185 0 11.805 0c1.621 0 2.935 1.314 2.935 2.935V39.27c0 1.621-1.314 2.935-2.935 2.935z",
  transform: "translate(2) translate(50.695 35.86)"
})), React.createElement("g", null, React.createElement("path", {
  fill: "#2AA964",
  d: "M34.695 36.899C22.883 45.509 1.68 39.069.092 23.222-.64 15.913 3.057 8.465 8.984 4.182c6.43-4.646 15.413-5.558 22.515-2.043 7.103 3.515 11.912 11.411 11.53 19.37-.292 6.036-3.473 11.846-8.334 15.39",
  transform: "translate(2) translate(0 49)"
}), React.createElement("path", {
  stroke: "#FFF",
  strokeWidth: 2.392,
  d: "M34.695 36.899C22.883 45.509 1.68 39.069.092 23.222-.64 15.913 3.057 8.465 8.984 4.182c6.43-4.646 15.413-5.558 22.515-2.043 7.103 3.515 11.912 11.411 11.53 19.37-.292 6.036-3.473 11.846-8.334 15.39z",
  transform: "translate(2) translate(0 49)"
}), React.createElement("path", {
  fill: "#FFF",
  d: "M33.007 12.188c-.737-.742-1.866-.742-2.602 0L18.672 24.496l-5.204-5.487c-.737-.741-1.866-.741-2.602 0-.737.742-.737 1.977 0 2.719l6.53 6.822c.736.74 1.865.74 2.6 0l13.01-13.644c.737-.741.737-1.977 0-2.718",
  transform: "translate(2) translate(0 49)"
})));

var SvgRubbish = function SvgRubbish(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 86,
    height: 91,
    viewBox: "0 0 86 91",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgRubbish, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/rubbish.8dab5b72.svg";
export { ForwardRef as ReactComponent };